import React from 'react';
import { useTranslation } from '../../../../../core';
import { css, spacing, StyleSheet } from '../../../../../../styles';
import { DetailsSection } from '../DetailsSection';
import { IntegrationDetailsFields } from '../IntegrationDetailsFields';
import { IntegrationDetailsFooter } from '../IntegrationDetailsFooter';

/**
 * Renders general integration details and current status.
 *
 * @param {object} props
 * @param {Array<object>} props.fields
 * @param {boolean} props.hasChanges
 * @param {object} props.integration
 * @param {boolean} props.isSaving
 * @param {Function|null} props.onClose
 * @param {Function|null} props.onSave
 * @param {Array<object>} props.synchronizationFields
 * @param {object} props.updatedData
 */
export const GeneralTab = ({
    fields = [],
    hasChanges = false,
    integration,
    isSaving = false,
    onClose = null,
    onSave = null,
    synchronizationFields = [],
    updatedData
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={css(styles.sectionsGrid)}>
                <DetailsSection title={t('integrations.generalSettings')}>
                    <IntegrationDetailsFields
                        fields={fields}
                        integration={integration}
                        isSingleColumn={true}
                        updatedData={updatedData}
                    />
                </DetailsSection>
                <DetailsSection title={t('integrations.synchronization')}>
                    <IntegrationDetailsFields
                        fields={synchronizationFields}
                        integration={integration}
                        isSingleColumn={true}
                        updatedData={updatedData}
                    />
                </DetailsSection>
            </div>
            <IntegrationDetailsFooter
                hasUpdated={hasChanges}
                isSaving={isSaving}
                onClose={onClose}
                onSave={onSave}
            />
        </div>
    );
};

const styles = StyleSheet.create({
    sectionsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: spacing.s4,
        alignItems: 'start',
        '@media (max-width: 640px)': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        }
    }
});
